import { ExaminationSessionSlideService } from './../../../shared/src/lib/service/examination-session-slide.service';
import { ExaminationSessionService } from './../../../shared/src/lib/service/examination-session.service';
import { ExaminationSessionEffects } from './../../../shared/src/lib/store/effects/examination-session.effects';
import { WebsocketService } from './../../../shared/src/lib/service/websocket.service';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './manage-routing.module';

import { StoreModule } from '@ngrx/store';
import { reducers } from '../../../shared/src/lib/store/app.states';
import { EffectsModule } from '@ngrx/effects';
import { AuthEffects } from '../../../shared/src/lib/store/effects/auth.effects';
import { UserEffects } from '../../../shared/src/lib/store/effects/user.effects';
import { LilateEffects } from '../../../shared/src/lib/store/effects/lilate.effects';
import { WebSocketEffects } from '../../../shared/src/lib/store/effects/websockets.effects';
import { ExerciseEffects } from '../../../shared/src/lib/store/effects/exercise.effects';
import { ChartEffects } from '../../../shared/src/lib/store/effects/chart.effects';
import { ElateEffects } from '../../../shared/src/lib/store/effects/elate.effects';
import { SlideTextEffects } from '../../../shared/src/lib/store/effects/slide-text.effects';
import { AuthenticationService } from '../../../shared/src/lib/service/authentification.service';
import { KiwixiService } from '../../../shared/src/lib/kiwixi/kiwixi.service';
import { KiwixiGlobals } from '../../../shared/src/lib/kiwixi/kiwixi.globals';
import { MaterialService } from '../../../shared/src/lib/service/material.service';
import { MaterialModule } from '../../../shared/src/lib/material.module';
import { GroupService } from '../../../shared/src/lib/service/group.service';
import { RoutePermissionService } from '../../../shared/src/lib/service/routePermission.service';
import { ConversationService } from '../../../shared/src/lib/service/conversation.service';
import { AchievementManagerService } from '../../../shared/src/lib/service/achievementManager.service';
import { PlanService } from '../../../shared/src/lib/service/plan.service';
import { EventService } from '../../../shared/src/lib/service/event.service';
import { AchievementDoneservice } from '../../../shared/src/lib/service/achievementDone.service';
import { AchievementService } from '../../../shared/src/lib/service/achievement.service';
import { HelpNotifService } from '../../../shared/src/lib/service/helpNotif.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ManageComponent } from './manage.component';
import { FeatureModule } from '../../../shared/src/lib/feature/feature.module';
import { ExerciceService } from '../../../shared/src/lib/service/exercice.service';
import { FiltersService } from '../../../shared/src/lib/service/filters.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from '../../../shared/src/lib/interceptors/auth.interceptor';
import { SentryErrorHandler } from '../../../shared/src/lib/kiwixi/error.exception';
import { DictionnaryService } from '../../../shared/src/lib/service/dictionnary.service';
import { TranslateService, TranslateStore } from '@ngx-translate/core';
import { ExerciceQuestionService } from '../../../shared/src/lib/service/exerciceQuestion.service';
import { ExerciceAnswerChoiceService } from '../../../shared/src/lib/service/exerciceAnswerChoice.service';
import { ExaminationService } from '../../../shared/src/lib/service/examination.service';
import { ExaminationEffects } from '../../../shared/src/lib/store/effects/examination.effects';
import { ExerciceMediaService } from '../../../shared/src/lib/service/exerciceMedia.service';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { FeatureFuseModule } from '../../../shared/src/lib/feature-fuse/feature-fuse.module';
import { UserService } from '../../../shared/src/lib/service/user.service';
import { StudentService } from '../../../shared/src/lib/service/student.service';
import { ExaminationSlidesTextService } from '../../../shared/src/lib/service/examination-slide-text.service';
import { ExaminationVariantService } from '../../../shared/src/lib/service/examination-variant.service';
import { ExaminationSlidesService } from '../../../shared/src/lib/service/examination-slides.service';
import { TeacherService } from '../../../shared/src/lib/service/teacher.service';
import { ExaminationSessionAttendeeLogsConnexionService } from '../../../shared/src/lib/service/examination-session-attendee.service';
import { LogActionService } from '../../../shared/src/lib/service/logAction.service';
import { ProfilePhotosService } from '../../../shared/src/lib/service/profilePhotos.service';
import { PathEventService } from '../../../shared/src/lib/service/pathEvent.service';
import { TestingService } from '../../../shared/src/lib/service/testing.service';
import { FormationService } from '../../../shared/src/lib/service/formation.service';
import { OccurrenceService } from '../../../shared/src/lib/service/occurrence.service';
import { SessionService } from '../../../shared/src/lib/service/session.service';
import { ScrollToService } from '../../../shared/src/lib/service/scrollto.service';
import { DatePipe, registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { ExportsService } from '../../../shared/src/lib/service/export.service';
import { OnlineMeetingsService } from '../../../shared/src/lib/service/onlineMeetings.service';
import { CompanyService } from '../../../shared/src/lib/service/company.service';
import { CertificationService } from '../../../shared/src/lib/service/certification.service';
import { LanguageService } from '../../../shared/src/lib/service/language.service';
import { SiteService } from '../../../shared/src/lib/service/site.service';
import { TimezoneService } from '../../../shared/src/lib/service/timezone.service';
import { CorporateService } from '../../../shared/src/lib/service/corporate.service';
import { GroupFormationsService } from '../../../shared/src/lib/service/groupFormations.service';
import { ModeFinancementService } from '../../../shared/src/lib/service/mode-financement.service';
import { PartnersService } from '../../../shared/src/lib/service/partners.service';
import { manageConfig } from './manage.config';
import { NotificationService } from '../../../shared/src/lib/service/notification.service';
import { sentryProviders } from '../../../shared/src/lib/sentry/sentry.config';
import { AiExamService } from '../../../shared/src/lib/service/aiExam.service';
import { ProctoringService } from '../../../shared/src/lib/service/proctoring.service';
registerLocaleData(localeFr, 'fr');
@NgModule({
  declarations: [
    ManageComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MaterialModule,
    FeatureModule,
    FeatureFuseModule,

    // Store
    StoreModule.forRoot(reducers, {}),
    EffectsModule.forRoot([AuthEffects, UserEffects, LilateEffects, ElateEffects,
      ExerciseEffects, ExaminationEffects, SlideTextEffects, WebSocketEffects, ChartEffects]),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    AuthenticationService,
    KiwixiService,
    KiwixiGlobals,
    MaterialService,
    GroupService,
    RoutePermissionService,
    ConversationService,
    AchievementManagerService,
    PlanService,
    EventService,
    AchievementDoneservice,
    AchievementService,
    HelpNotifService,
    ExerciceService,
    FiltersService,
    DictionnaryService,
    TranslateService,
    TranslateStore,
    ExerciceQuestionService,
    ExerciceAnswerChoiceService,
    ExaminationService,
    ExaminationSlidesTextService,
    ExaminationSlidesService,
    ExaminationVariantService,
    WebsocketService,
    ExaminationSessionService,
    ExaminationSessionSlideService,
    ExerciceMediaService,
    YouTubePlayerModule,
    UserService,
    StudentService,
    TeacherService,
    ExaminationSessionAttendeeLogsConnexionService,
    LogActionService,
    ProfilePhotosService,
    PathEventService,
    TestingService,
    FormationService,
    OccurrenceService,
    SessionService,
    ScrollToService,
    ExportsService,
    OnlineMeetingsService,
    CompanyService,
    CertificationService,
    LanguageService,
    SiteService,
    TimezoneService,
    CorporateService,
    GroupFormationsService,
    ModeFinancementService,
    PartnersService,
    manageConfig.providers,
    DatePipe,
    NotificationService,
    sentryProviders,
    AiExamService,
    ProctoringService
  ],
  bootstrap: [ManageComponent]
})
export class AppModule { }
